import { FunctionComponent, useEffect, useRef, useState } from "react";
import "./PracticeExam.scss";
import Table from "../../Components/Table/Table";
import CustomToolbar from "../../Components/Table/components/CustomToolbar";
import ButtonField from "../../Components/Button/ButtonField";
import { Columns } from "../../Components/Table/ITable";
import { GridRenderCellParams } from "@mui/x-data-grid";
import { IPracticeExam } from "./IPracticeExam";
import { useAppDispatch, useAppSelector } from "../../Redux/Store/Hooks";
import Dialog from "../../Components/Dialog/Dialog";
import PracticeExamForm from "./PracticeExamForm";
import ResponseDialog from "../../Components/ResponseDialog/ResponseDialog";
import TableSearch from "../../Components/Table/components/TableSearch";
import { ReactComponent as Delete } from "../../Assets/Images/delete.svg";
import { ReactComponent as Edit } from "../../Assets/Images/edit.svg";
import { IDeleteDialog } from "../../Components/DeleteDialog/IDeleteDialog";
import IconButtonField from "../../Components/Button/IconButtonField";
import { SvgIcon } from "@mui/material";
import DeleteDialog from "../../Components/DeleteDialog/DeleteDialog";
import { ReactComponent as RefreshButton } from "../../Assets/Images/RefreshButton.svg";
import { listPracticeExam } from "../../Redux/Slices/PracticeExam/ListPracticeExamSlice";
import { clearAddPracticeExamResponse } from "../../Redux/Slices/PracticeExam/AddPracticeExamSlice";
import {
  clearDeletePracticeExamResponse,
  deletePracticeExam,
} from "../../Redux/Slices/PracticeExam/DeletePracticeExamSlice";
import { clearEditPracticeExamResponse } from "../../Redux/Slices/PracticeExam/EditPracticeExamSlice";
import { listSideMenuPermission } from "../../Redux/Slices/SideMenuPermission/ListSideMenuPermissionSlice";
import { listQuestionType } from "../../Redux/Slices/QuestionType/ListQuestionTypeSlice";
import { listQuestionSubType } from "../../Redux/Slices/QuestionSubType/ListQuestionSubTypeSlice";
import LibraryAddIcon from "@mui/icons-material/LibraryAdd";
// import { listPracticeExamModel } from "../../Redux/Slices/PracticeExamModel/ListPracticeExamModelSlice";

interface PracticeExamProps { }

const PracticeExam: FunctionComponent<PracticeExamProps> = () => {
  const [dialogOpen, setDialogOpen] = useState<boolean>(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState<boolean>(false);
  const [deleteDialogData, setDeleteData] = useState<IDeleteDialog>({});
  const [initialValues, setInitialValues] = useState<IPracticeExam>({});
  const [fullScreen, setFullScreen] = useState<boolean>(false);
  const dispatch = useAppDispatch();
  const { data: listPracticeExams } = useAppSelector(
    (state) => state.ListPracticeExamSlice,
  );
  const { data: addPracticeExam } = useAppSelector(
    (state) => state.AddPracticeExamSlice,
  );
  const { data: EditPracticeExam } = useAppSelector(
    (state) => state.EditPracticeExamSlice,
  );
  const { data: deletePracticeExams } = useAppSelector(
    (state) => state.DeletePracticeExam,
  );
  // user permisssion
  const { data: userPermissionlist } = useAppSelector(
    (state) => state.SideMenuPermission,
  );

  const to = "masters";

  const filteredList = userPermissionlist.Dashboard.filter(
    (item: any) => item.to === to,
  );
  const fliterdata: any = filteredList[0]?.items;
  const finaldata = fliterdata[3];

  const formRef = useRef<HTMLFormElement>(null);
  const columns: Columns = [
    {
      field: "index",
      renderHeader: () => <b>S.No</b>,
      width: 90,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "name",
      renderHeader: () => <b>Practice Exam</b>,
      flex: 1,
      type: "string",
      headerAlign: "left",
    },

    {
      field: "question_type_name",
      renderHeader: () => <b>Practice Exam Type</b>,
      flex: 1,
      type: "string",
      headerAlign: "left",
      renderCell: (params: GridRenderCellParams) => {
        return (
          <>
            <div>
              {params?.row?.question_type_name === null
                ? "-"
                : params?.row?.question_type_name}
            </div>
          </>
        );
      },
    },
    {
      field: "description",
      renderHeader: () => <b>Description</b>,
      flex: 1,
      type: "string",
      headerAlign: "left",
    },
    {
      field: "status",
      renderHeader: () => <b>Status</b>,
      flex: 1,
      type: "string",
      headerAlign: "left",
      cellClassName: (params) =>
        `activename ${params.row.status ? "active" : "inactive"}`,

      valueFormatter: (params) =>
        params.value === true ? "Active" : "Inactive",
    },
    {
      field: "action",
      renderHeader: () => <b>Action</b>,
      flex: 1,
      type: "actions",
      renderCell: (params: GridRenderCellParams<IPracticeExam>) => {
        return (
          <>
            <IconButtonField
              disabled={finaldata?.permissions?.edit === false}
              onClick={() => {
                setInitialValues({ ...params.row });
                setDialogOpen(true);
                dispatch(
                  listQuestionSubType({
                    questiontype_id: params.row?.question_type_id,
                  }),
                );
              }}
            >
              <SvgIcon sx={{ fill: "none" }} component={Edit} inheritViewBox />
            </IconButtonField>
            <IconButtonField
              toolTip="Duplicate"
              disabled={finaldata?.permissions?.add === false}
              onClick={() => {
                const duplicatedRow = { ...params.row };
                delete duplicatedRow.id;
                delete (duplicatedRow as any).index;
                duplicatedRow.name = `${duplicatedRow.name}-1`;
                setInitialValues(duplicatedRow);
                setDialogOpen(true);
                dispatch(
                  listQuestionSubType({
                    questiontype_id: params.row?.question_type_id,
                  })
                );
              }}
            >
              <LibraryAddIcon sx={{ fontSize: 20, color: "#4785ff" }} />
            </IconButtonField>
            <IconButtonField
              disabled={finaldata?.permissions?.delete === false}
              onClick={() => {
                setDeleteData({ id: params.id, name: params?.row?.name });
                setDeleteDialogOpen(true);
              }}
            >
              <SvgIcon component={Delete} inheritViewBox />
            </IconButtonField>
          </>
        );
      },
    },
  ];

  const PracticeExam = Array.isArray(listPracticeExams?.data)
    ? listPracticeExams?.data.map((user, index) => ({
      ...user,
      index: index + 1,
    }))
    : [];

  useEffect(() => {
    dispatch(listPracticeExam());
    dispatch(listQuestionType());
    // dispatch(listSideMenuPermission());
  }, [addPracticeExam, EditPracticeExam, deletePracticeExams, dispatch]);
  useEffect(() => {
    return () => {
      dispatch(clearAddPracticeExamResponse());
      dispatch(clearEditPracticeExamResponse());
      dispatch(clearDeletePracticeExamResponse());
    };
  }, [dispatch]);

  return (
    <>
      <Table rows={PracticeExam ?? []} columns={columns}>
        <CustomToolbar>
          {/* <h6>Practice Exam</h6> */}
          <h6></h6>
          <TableSearch />
          <ButtonField
            className="tabel_add_new_button"
            onClick={() => setDialogOpen(true)}
            toolTip="Add new"
            disabled={finaldata?.permissions?.add === false}
          >
            Add new
          </ButtonField>
          <IconButtonField
            className="refresh_btn"
            toolTip="Refresh"
            onClick={() => dispatch(listPracticeExam())}
          >
            <SvgIcon
              className="refresh_svg_icon"
              component={RefreshButton}
              inheritViewBox
            />
          </IconButtonField>
        </CustomToolbar>
      </Table>

      <Dialog
        open={dialogOpen}
        dialogClassName="dialog_mid_large"
        // maxWidth={false}
        // fullWidth={true}
        Dialog_Title={`${(initialValues as IPracticeExam).id ? "Update" : "Add"
          } Practice Exam`}
        Dialog_Content={
          <PracticeExamForm
            formRef={formRef}
            initialValues={initialValues}
            setInitialValues={setInitialValues}
            onFullScreenToggle={setFullScreen}
          />
        }
        fullScreen={fullScreen}
        Dialog_Actions={
          <>
            <ButtonField
              className="form_cancel_button"
              onClick={() => setDialogOpen(false)}
            >
              Cancel
            </ButtonField>
            <ButtonField
              className="form_save_button"
              onClick={() => formRef.current?.requestSubmit()}
            >
              Save
            </ButtonField>
          </>
        }
      />
      <ResponseDialog response={addPracticeExam} parentDialog={setDialogOpen} />
      <ResponseDialog
        response={EditPracticeExam}
        parentDialog={setDialogOpen}
      />
      <DeleteDialog
        deleteableName={deleteDialogData.name ?? ""}
        open={deleteDialogOpen}
        setOpen={setDeleteDialogOpen}
        deleteFunction={() => {
          dispatch(deletePracticeExam(deleteDialogData.id));
        }}
        response={deletePracticeExams}
      />
    </>
  );
};

export default PracticeExam;
